
        var result = require("!!../../../../node_modules/css-loader/index.js!./training.book.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Client/app/views/training/training.book.component.css
// module id = 1248
// module chunks = 0